/**
 * A client-side navigation aborts every request still in flight, and the
 * browser reports each abort as a plain status-0 failure with nothing tying it
 * to the navigation that caused it. Attributing one costs a hand-read of a
 * session waterfall (WPX-4004). Stamping the elapsed time onto every Dynatrace
 * event instead makes it a filter.
 *
 * `useReactRouterDomExoNavigationEmitter` emits from a mount-time effect, so
 * the initial route render reaches `onNavigate` and consumes navigation 1;
 * navigation 2 and later is an in-session navigation. Anything that fails before
 * that first mount carries no fields at all. Both properties are pinned by
 * tests in navigation.spec.ts.
 */
let lastNavigationAt: number | undefined;
let navigationCount = 0;

export function markNavigation() {
  lastNavigationAt = performance.now();
  navigationCount += 1;
}

export function getNavigationTiming() {
  if (lastNavigationAt === undefined) {
    return {};
  }

  return {
    exo_ms_since_last_navigation: Math.round(
      performance.now() - lastNavigationAt,
    ),
    exo_navigation_count: navigationCount,
  };
}
